import type { ApolloError, DataProxy } from '@apollo/client';
import { useMutation } from '@apollo/client';

import { XcpEntityPageUnfollowDocument } from '../../graphql/mutations/entity-page-unfollow.gql-types';
import { useCompanyData } from '../use-company-data/use-company-data';
import { useError } from '../use-error';

const useUnfollowCompanyMutation = ({
  entityPageId,
}: {
  entityPageId: string;
}) => {
  // @ts-expect-error TS(2339) FIXME: Property 'showError' does not exist on type 'unkno... Remove this comment to see the full error message
  const { showError } = useError();
  const { unfollowCompany } = useCompanyData();
  const [handleUnfollowCompany] = useMutation(XcpEntityPageUnfollowDocument, {
    update: (cache: DataProxy, props: any) => {
      if (props.data?.entityPageUnfollow?.error) {
        showError({
          message: props.data?.entityPageUnfollow?.error?.message,
        });
      } else {
        unfollowCompany({ entityPageId });
      }
    },
    onError: (error: ApolloError) => {
      showError({ message: error.message, error });
    },
  });

  return {
    handleUnfollow: () =>
      handleUnfollowCompany({ variables: { followedId: entityPageId } }),
  };
};

export { useUnfollowCompanyMutation };
